import { FormControl } from "baseui/form-control";
import { Input } from "baseui/input";
import { Select } from "baseui/select";
import { BacnetPropertyIds } from "../../../services/mapping/bacnet";
import { IAutomationObject } from "../../../automationObjects";
import { AppPropertySelector } from "../../../components/AppPropertySelector";

const BacnetPropertyMappingBasicForm = (props: { bacnetProperty, onBacnetPropertyChange, propertyName, onPropertyNameChange, targetApp: IAutomationObject }) => {
    const onBacnetPropertyChanged = (e: any) => props.onBacnetPropertyChange(e.value);
    const onPropertyNameChanged = (e: any) => props.onPropertyNameChange(e);


    return (
        <>
            <FormControl
                label={() => "BACnet Property"}
                caption={() => "Select the Property of the BACnet Object"}
            >
                <Select
                    options={b3}
                    value={props.bacnetProperty}

                    required
                    placeholder="Select property"
                    onChange={onBacnetPropertyChanged}
                />

            </FormControl>
            <FormControl
                label={() => "Property Name"}
                caption={() => "Enter the name of the Object property"}
            >
                <>
                    <AppPropertySelector onSelectionChanged={onPropertyNameChanged} app={props.targetApp}></AppPropertySelector>
                </>
            </FormControl>
        </>
    )
}


export default BacnetPropertyMappingBasicForm;


const bacnetPropertys = Object.keys(BacnetPropertyIds).filter((item) => {
    return isNaN(Number(item));
});
const b3 = bacnetPropertys.map((item: any, index: number) => { return { label: item, id: index } });
